const currentLayOut = localStorage.getItem('mainLayoutType') || 'Vertical'
const currentLayOutNavs = require(`../${currentLayOut && currentLayOut.toLowerCase() === 'vertical' ? 'vertical' : 'horizontal'}-nav-menu/navMenuItems.js`).default
let selectedBookMarks = []
const extractNav = (r, a) => {
  if (Array.isArray(a.submenu)) {
    return a.submenu.reduce(extractNav, r)
  }

  if (Array.isArray(a.items)) {
    return a.items.reduce(extractNav, r)
  }

  const isBookMarked = selectedBookMarks.length ? selectedBookMarks.find(x => x.url === a.url) : false
  const tempO = {
    title: a.name,
    url: a.url,
    icon: a.icon,
    is_bookmarked: isBookMarked || false,
    permissions: a.permissions,
    roles: a.roles
  }

  r.push(tempO)

  return r
}

export const navItemPins = () => {
  selectedBookMarks = localStorage.getItem('selectedBookMarks') ? JSON.parse(localStorage.getItem('selectedBookMarks')) : []
  return {
    pages: {
      key: 'title',
      data: [...currentLayOutNavs.reduce(extractNav, []).filter(x => x)]
    }
  }
}
export default navItemPins()
